import { defineMessages } from 'react-intl';

export default defineMessages({
  inventory: {
    id: 'itemtype.inventory.title',
    defaultMessage: 'Inventory'
  },
  noninventory: {
    id: 'itemtype.noninventory.title',
    defaultMessage: 'Non Inventory'
  },
  matrix: {
    id: 'itemtype.matrix.title',
    defaultMessage: 'Matrix'
  },
  shipping: {
    id: 'itemtype.shipping.title',
    defaultMessage: 'Shipping'
  },
  serialized: {
    id: 'itemtype.serialized.title',
    defaultMessage: 'Serialized'
  },
  batch: {
    id: 'itemtype.batch.title',
    defaultMessage: 'Batch'
  },
  service: {
    id: 'itemtype.service.title',
    defaultMessage: 'Service'
  },
  bundle: {
    id: 'itemtype.bundle.title',
    defaultMessage: 'Bundle'
  },
  giftcertificate: {
    id: 'itemtype.giftcertificate.title',
    defaultMessage: 'Gift Certificate'
  },
  service_charge: {
    id: 'itemtype.service_charge.title',
    defaultMessage: 'Service Charge'
  }
});
